import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import useAuthStore from "store/authStore";

const GUARDS_STALE_TIME = 60000;

const useGuards = ({ enabled = true } = {}) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get("/guards");
		const data = res?.data?.data;
        const authorization = data?.authorization;
        if (accessToken === useTokenStore.getState().accessToken
            && Array.isArray(authorization?.roles) && Array.isArray(authorization?.permissions)) {
            useAuthStore.getState().storeAuthorization(authorization);
        }
        return data;
	};

	return useQuery(["guards"], () => fetch(), {
		enabled,
		retry: 1,
		staleTime: GUARDS_STALE_TIME,
		refetchOnWindowFocus: true,
		keepPreviousData: true,
	});
};

export default useGuards;
